import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

/**
 * Floating "scroll to top" button. Appears after user scrolls 600px, sits above the WhatsApp FAB.
 */
const ScrollToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 600);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <AnimatePresence>
            {visible && (
                <motion.button
                    onClick={scrollUp}
                    initial={{ opacity: 0, scale: 0.7, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.7, y: 20 }}
                    transition={{ duration: 0.25 }}
                    aria-label="Sayfanın en üstüne dön"
                    title="En üste dön"
                    className="fixed right-5 bottom-24 z-[9998] w-12 h-12 rounded-full bg-gold text-emerald_deep shadow-xl hover:bg-gold-hover hover:scale-110 transition-all flex items-center justify-center"
                    style={{ backgroundColor: "var(--c-gold)" }}
                    data-testid="scroll-to-top-btn"
                >
                    <ArrowUp className="w-5 h-5" strokeWidth={2.5} />
                </motion.button>
            )}
        </AnimatePresence>
    );
};

export default ScrollToTop;
